import * as Linking from "expo-linking";
import * as React from "react";
import {ContactUs} from "./contact-us";
import {ApplicationFeatures} from "./application-features";
import {AboutUs} from "./about-us";
import {AsyncButtonWithSpinner} from "../../../shared/async-button-with-spinner";
import {WhatCanIRecycle} from "./what-can-i-recycle";
import { Alert } from "../../../shared/alert";
import { Button } from "../../../shared/button";
import { Text } from '@ui-kitten/components'
import { View } from 'react-native'
import {SectionTitle} from "./section-title";

const TownLine = ({ number, children }) => <Text style={{color: 'white', fontWeight: 'bold'}}><Text style={{ fontWeight: 'bold', color: '#a0ca45'}}>{number}</Text> {children}</Text>

export const HomeScreen = ({isSignIn, setCurrentPage, onSignOut}) => {
    return <View style={{marginTop: 40, marginBottom: 20, padding: 10 }}>
        {!isSignIn && <Alert button={<Button onPress={() => setCurrentPage(1)}>Login Now</Button>}>
            <Text style={{color: 'white'}}>To start with WeCycle !</Text>
        </Alert>}

        <View style={{padding: 20, paddingTop: 0, paddingBottom: 50}}>
            <View>
                <SectionTitle>WE COME TO YOU!</SectionTitle>

                <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                    <View>
                        <TownLine number="1">Calodyne</TownLine>
                        <TownLine number="2">Cap malheureux</TownLine>
                        <TownLine number="3">Pereybère</TownLine>
                        <TownLine number="4">Grand Baie</TownLine>
                        <TownLine number="5">Pointe aux Cannoniers</TownLine>
                        <TownLine number="6">Mont Choisy</TownLine>
                        <TownLine number="7">Trou aux Biches</TownLine>
                        <TownLine number="8">Pointe aux Piments</TownLine>
                        <TownLine number="9">Albion</TownLine>
                    </View>
                    <View>
                        <TownLine number="10">Flic en flac</TownLine>
                        <TownLine number="11">Tamarin</TownLine>
                        <TownLine number="12">Rivière Noire</TownLine>
                        <TownLine number="13">Beau Bassin</TownLine>
                        <TownLine number="14">Moka</TownLine>
                        <TownLine number="15">Curepipe</TownLine>
                        <TownLine number="16">Floréal</TownLine>
                    </View>
                </View>
            </View>
            <AboutUs onPressWebsite={() => Linking.openURL('https://www.wecycle.mu') }/>
            <WhatCanIRecycle onPressWebsite={() => Linking.openURL('https://www.wecycle.mu') }/>
            <ApplicationFeatures goPickupService={() => setCurrentPage(1)}/>
            <ContactUs onPressPhone={() => Linking.openURL('tel:+2302486707')}
                       onPressEmail={() => Linking.openURL('mailto:contact@wecycle.mu')}
                       onPressFB={() => Linking.openURL('https://www.facebook.com/wecycleltd')}
                       // onPressLinkedIn={() => Linking.openURL('https://www.linkedin.com/company/wecycle-ltd')}
                       onPressInstagram={() => Linking.openURL('https://www.instagram.com/wecycle_ltd')}/>
            {isSignIn && <AsyncButtonWithSpinner appearance="ghost" onPress={onSignOut}>Sign Out</AsyncButtonWithSpinner>}
        </View>
    </View>
}